import { DataGroupDtoToEntity } from "src/app/features/DataGroup/services/mappers/DataGroupDtoToEntity";
import type { DataGroupDto } from "src/app/features/DataGroup/types/DataGroupDto";
import type { DataGroupEntity } from "src/app/features/DataGroup/types/DataGroupEntity";
import type { ResourcePageDto } from "../../../../../core/types/be/ResourcePageDto";
import type { ResourcePageEntity } from "../../../../../core/types/fe/entities/ResourcePageEntity";

export const DataGroupTableDtoMapper = (input: Readonly<ResourcePageDto<DataGroupDto>>): ResourcePageEntity<DataGroupEntity> => {
    return {
        list: input.list ? input.list.map(DataGroupDtoToEntity) : [],
        currentPage: input.currentPage,
        totalPages: input.totalPages,
        totalNumberOfResults: input.totalNumberOfResults,
    };
};
